import React from "react";
import "./style.scss";
import { Button } from "@material-ui/core";
function SessionDetails() {
  return (
    <div className="session-details">
      <div className="col-md-10 session-detailwhole">
        <div className=".session-detailHeading">
          <p className="display-heading">SESSION 3 DETAILS</p>
        </div>

        <table id="session">
          <tbody>
            <tr>
              <td className="session-question">
                <p>START DATE</p>
              </td>
              <td className="session-answer">
                <p>DD-MM-YY</p>
              </td>
            </tr>
            <tr>
              <td className="session-question">
                <p>START TIME</p>
              </td>
              <td className="session-answer">
                <p>00:00</p>
              </td>
            </tr>
            <tr>
              <td className="session-question">
                <p>SESSION DURATION</p>
              </td>
              <td className="session-answer">
                <p>2.5</p>
              </td>
            </tr>
            <tr>
              <td className="session-question">
                <p>SESSION FORMAT</p>
              </td>
              <td className="session-answer">
                <p>Offline</p>
              </td>
            </tr>
            <tr>
              <td className="session-question">
                <p>VIDEO LINK</p>
              </td>
              <td className="session-answer">
                <p>NA</p>
              </td>
            </tr>
            <tr>
              <td className="session-question">
                <p>SESSION GOALS -1</p>
              </td>
              <td className="session-answer">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard
                </p>
              </td>
            </tr>
            <tr>
              <td className="session-question">
                <p>SESSION GOALS -2</p>
              </td>
              <td className="session-answer">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </p>
              </td>
            </tr>
            <tr>
              <td className="session-question">
                <p>DESIRED OUTCOME</p>
              </td>
              <td className="session-answer">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <Button
          className="back-sessionDetail"
          // style={{
          //                   backgroundColor: "#3AC2D7",
          //                   color: "#fff",
          //                   width: "150px",
          //                   fontFamily: "Montserrat",
          //                   fontSize: "16px",
          //                   fontWeight: 600,
          //                   lineHeight: "25px",
          //                   letterSpacing: "0.02857em",
          //                   textTransform: "uppercase",
          //                   marginTop: "20px",
          //                 }}
          variant="outlined"
        >
          BACK
        </Button>
      </div>
    </div>
  );
}

export default SessionDetails;
